import ValorService from "@/services/valor.service";

export default {
  namespaced: true,
  state: {
    planos: [],
    valores: [],
    valor: {},
    loading: false,
    error: null,
  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setError: (state, error) => state.error = error,
    setPlanos: (state, planos) => state.planos = planos,
    setValores: (state, valores) => state.valores = valores,
    setValor: (state, valor) => state.valor = valor,
  },
  actions: {
    ['resetPlanos']({ commit }) {
      commit('setPlanos', [])
    },
    async ['buscaPlano']({ commit },
      {
        uf,
        produto,
        tipo_plano,
        contratacao,
        cidade,
        compulsorio,
        coparticipacao,
        acomodacao,
        regras_aceitacao,
        credenciado,
        entidade,
        profissao,
        administradora,
        faixas,
        grupos_faixas,
        detalhes
      }
    ) {
      try {
        commit('setLoading', true)
        return ValorService.busca(
          uf,
          produto,
          tipo_plano,
          contratacao,
          cidade,
          compulsorio,
          coparticipacao,
          acomodacao,
          regras_aceitacao,
          credenciado,
          entidade,
          profissao,
          administradora,
          faixas,
          grupos_faixas,
          detalhes
        ).then(resp => {
          commit('setLoading', false)
          return Promise.resolve(resp)
        }, error => {
          commit('setLoading', false)
          return Promise.reject(error)
        })
      } catch (error) {
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    }
  },
  getters: {
    getLoading: state => state.loading,
    getError: state => state.error,
    getPlanos: state => state.planos,
    setValores: state => state.valores,
    setValor: state => state.valor
  }
};
